// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import 'lib-flexible/flexible.js'
import './assets/common.css'
import common from '@/utils/common.js'
import LocalStorage  from '@/lib/Zplug'
// import $ from 'n-zepto'
// 富文本编辑器样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

try {
    if (location.href.indexOf('Custom') === -1 && location.href.indexOf('article') === -1 && location.href.indexOf('customGuide') === -1) {
        document.title = '柏克学'
    }
} catch(e) {}


Vue.use(MintUI)
Vue.use(LocalStorage)
Vue.prototype.$tool = common;
Vue.config.productionTip = false
axios.defaults.baseURL = process.env.API_ROOT

Vue.prototype.uploadAxios = (option) => {
    let userInfo = localStorage.getItem('userInfo');
    let token = JSON.parse(userInfo).token
    return new Promise((resolve, reject) => {
        var axios_instance = axios.create({
            transformRequest: [function (data) {
                return data;
            }],
            headers: {
                'Content-Type': 'multipart/form-data',
                'authorization':token,
            },
        });
        axios_instance.post(option.url, option.data).then(function (res) {
            resolve(res.data);
        }).catch(function (error) {
            reject(error);
        });
    });
};
// 获取屏幕高度
Vue.prototype.screenHeight = window.screen.height;

//路由拦截
router.beforeEach((to, from, next) => {
    // ...
    if(to.name=="outerChain"){
        //如果是调到外部链接，则缓存前一个路由，以便返回时调用
        localStorage.setItem('fromRouterName',from.name);
    }
    next();
  })
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js